import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggerService } from 'src/app/core/services/logger.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces';
import { BreakpointObserver } from '@angular/cdk/layout';

import { Location } from '@angular/common';

import * as userSelector from '../../core/store/order/order.selectors';
import { Observable } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidatorFn,
  ValidationErrors,
  AbstractControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  $isLoggedIn: Observable<boolean>;
  success: boolean;
  isPasswordVisible = [false, false];
  token: string;
  email: string;
  resetForm: FormGroup;
  isSubmitting = false;

  constructor(
    private authService: AuthService,
    public breakpointObserver: BreakpointObserver,
    private store: Store<AppState>,
    private _formBuilder: FormBuilder,
    private location: Location,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private logger: LoggerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      dialog: MatDialog;
    }
  ) {}

  ngOnInit() {
    this.$isLoggedIn = this.store.select(userSelector.getIsLoggedIn);

    this.$isLoggedIn.subscribe((isLogged: boolean) => {
      if (isLogged) {
        this.closeDialog();
        this.location.replaceState('/');
      }
    });

    this.route?.queryParamMap?.subscribe((params) => {
      this.token = params.get('reset-password') || '';
      this.email = params.get('email') || '';
      if (!this.token.length || !this.email.length) this.closeDialog();
    });

    this.resetForm = this._formBuilder.group({
      password1: new FormControl('', [Validators.required, Validators.minLength(8)]),
      password2: new FormControl('', [Validators.required, this.isSamePasswords()])
    });
  }

  submitReset(pass1: string, pass2: string) {
    if (this.isSubmitting) return;
    if (this.resetForm?.valid && this.token?.length && this.email?.length) {
      this.isSubmitting = true
      this.authService.resetPassword(pass1, pass2, this.token, this.email).subscribe({
        next: () => {
          this.success = true
          this.isSubmitting = false
        },
        error: (response) => {
          this.logger.log('POST call in error', response);
          this.snackBar.open('Une erreur a eu lieu 😰');
          this.success = false
          this.isSubmitting = false
        }
      });
    }
  }

  isSamePasswords(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const different = this.resetForm?.get('password1').value !== this.resetForm?.get('password2').value;
      return different ? { mismatch: { value: control.value } } : null;
    };
  }

  closeDialog() {
    this.data.dialog.closeAll();
  }

  togglePasswordVisibility(index: 0 | 1) {
    this.isPasswordVisible[index] = !this.isPasswordVisible[index];
  }
}
